import React, { useContext, useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import { FormProvider, useForm } from 'react-hook-form'
import { useSnackbar } from 'notistack'
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid, ToggleButtonGroup
} from '@mui/material'
import SubmitButton from '../../commonUIComponents/SubmitButton'
import avatarService from '../../../services/avatarService'
import userService from '../../../services/userService'
import AvatarUploadDropZone from './AvatarUploadDropZone'
import AvatarBoxButton from './AvatarBoxButton'
import { UserInfoContext } from '../../contexts/UserInfoContext'

const UpdateAvatarPage = ({ open, onClose, submitOnSuccess }) => {
  const { userInfo, setUserInfo } = useContext(UserInfoContext)
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(true)
  const [defaultAvatars, setDefaultAvatars] = useState()
  const methods = useForm({ mode: 'onChange' })
  const { handleSubmit, register, formState: { errors } } = methods

  const fetchDefaultAvatars = () => {
    setLoading(true)
    avatarService.getDefaultAvatars()
      .then(res => {
        setDefaultAvatars(res.avatars)
      })
      .catch(err => enqueueSnackbar(err, { variant: 'error' }))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchDefaultAvatars()
  }, [])

  const submitHandler = ({ avatarId }) => {
    const form = { avatarId }
    form.avatarImageUrl = methods.getValues('avatarImageUrl')
    if (form.avatarImageUrl) {
      return avatarService.createAvatar(form)
        .then(res => {
          userService.updateUserById({ avatarId: res.id })
            .then(res => {
              onClose()
              submitOnSuccess()
              enqueueSnackbar('Successfully updated the avatar!', { variant: 'success' })
            })
        })
        .catch(err => enqueueSnackbar(err.response?.data?.message, { variant: 'error' }))
    } else if (avatarId) {
      return userService.updateUserById({ ...form })
        .then(res => {
          onClose()
          submitOnSuccess()
          enqueueSnackbar('Successfully updated the avatar!', { variant: 'success' })
        })
    }
  }

  const [value, setValue] = React.useState(userInfo.avatarId)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const AvatarBoxButtonList = ({ loading }) => {
    return (
      <>
        <Grid item xs={12} sx={{ display: { xs: 'none', md: 'block' } }}>
          <Grid container justifyContent="flex-start">
            <ToggleButtonGroup
              value={value}
              exclusive
              onChange={handleChange}
              aria-label="avatar selection"
              sx={{ flexWrap: 'wrap' }}
            >
              <AvatarUploadDropZone methodName="avatarImageUrl" width={72} height={72} />
              {defaultAvatars?.map(avatar => (
                <AvatarBoxButton key={avatar.avatarImageUrl} loading={loading} avatar={avatar} width={72} height={72} />
              ))}
            </ToggleButtonGroup>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ display: { xs: 'block', md: 'none' } }}>
          <Grid container justifyContent="center">
            <ToggleButtonGroup
              value={value}
              exclusive
              onChange={handleChange}
              aria-label="avatar selection"
              sx={{ flexWrap: 'wrap', justifyContent: 'center' }}
            >
              <AvatarUploadDropZone methodName="avatarImageUrl" width={36} height={36} />
              {defaultAvatars?.map(avatar => (
                <AvatarBoxButton key={avatar.avatarImageUrl} loading={loading} avatar={avatar} width={36} height={36} />
              ))}
            </ToggleButtonGroup>
          </Grid>
        </Grid>
      </>
    )
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: '#000000',
          borderRadius: 5
        }
      }}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <DialogTitle sx={{ ml: 2 }}>Avatar Image</DialogTitle>
          <DialogContent>
            <Grid container>
              <AvatarBoxButtonList loading={loading} />
            </Grid>
            <DialogActions>
              <Button onClick={onClose}>Cancel</Button>
              <SubmitButton buttonLabel="Save" loadingLabel="Saving ..." textAlign="right"/>
            </DialogActions>
          </DialogContent>
        </form>
      </FormProvider>
    </Dialog>
  )
}

export default UpdateAvatarPage
